import { createStore } from "vuex";

const origin = window.location.origin;
const languages = appData?.master?.languages;

const getShortcuts = () => {
  const maxShortcuts = 10;
  const shortcuts = [...Array(maxShortcuts)]
    .map((u, i) => {
      const key = `shortcut_${i + 1}`;
      if (!appData.master[`${key}_url`]) return;
      return {
        url: appData.master[`${key}_url`],
        img: appData.master[`${key}_img`],
      };
    })
    .filter((el) => el);

  return shortcuts;
};

function getUrl(url) {
  if (!url) return "";
  if (url?.includes("http")) return url;
  return origin + url;
}

const store = createStore({
  state: {
    master: appData?.master,
    languages: appData?.master?.languages,
    shortcuts: getShortcuts(),
    socials: appData?.social,
    items: appData?.items,
    categories: appData?.categories?.map((el, id) => ({
      ...el,
      anchor: `category-${id + 1}`,
    })),
    groups: appData?.groups?.map((el, id) => ({
      ...el,
      anchor: `group-${id + 1}`,
    })),
    custom: appData?.custom,
    active: {
      language: appData?.master?.languages[0],
    },
    contentAnchor: "",
    slider: appData?.master?.slider,
    home: getUrl(appData?.master?.home),
  },
  getters: {
    groups: (s) =>
      s.groups.map((group) => ({
        ...group,
        name: group.name[s.active.language],
      })),
    categories: (s) =>
      s.categories.map((category) => ({
        ...category,
        name: category.name[s.active.language].split("#$#")[0].trim(),
      })),
    items: (s) =>
      s.items.map((item) => ({
        ...item,
        name: item.name[s.active.language],
        unit: item.unit[s.active.language],
        desc: item.desc[s.active.language].filter((x) => x),
        url: getUrl(item?.url),
      })),
    hasGroups: (s) => !!s.master.use_groups,
    hasCategories: (s) => !!s.master.use_categories,
    hasLanguages: (s) => s.languages.length > 1,
    hasSocials: (s) => !!Object.keys(s.socials).length,
    // showSlider: (s, g) => g.sliderItems.length > 1,
    showSlider: () => false,
    slideGroups: (s) => !!s.slider,
    slideCategories: (s) => !!s.slider,
    sliderItems: (s, g) =>
      g.hasGroups
        ? g.groups.reduce((a, group) => {
            if (g.slideGroups) a.push(group);
            if (g.slideCategories)
              a.push(...g.categories.filter((cat) => cat.group === group.id));
            return a;
          }, [])
        : g.categories,
  },
  mutations: {
    observeElements(state, elements) {
      if (!elements.length) return;
      const ordered = elements
        .filter((el) => el.isIntersecting)
        .sort((a, b) => b.intersectionRatio - a.intersectionRatio);
      if (!ordered.length) return;
      state.contentAnchor = ordered[0].target.getAttribute("data-identifier");
    },
    setLanguage(state, language) {
      state.active.language = language;
      localStorage.setItem("language", language);
    },
  },
  modules: {},
});

function loadLanguage() {
  const savedLanguage = localStorage.getItem("language");
  const languageExists = languages.includes(savedLanguage);
  const language = languageExists ? savedLanguage : languages[0];
  store.commit("setLanguage", language);
}
loadLanguage();

export default store;
